// removed by extract-text-webpack-plugin
module.exports = {"pageHeader":"index__pageHeader__3vT7I","detail":"index__detail__2XwmM","row":"index__row__3D29O","breadcrumb":"index__breadcrumb__6T7Z4","tabs":"index__tabs__3vLXR","logo":"index__logo__1wHr9","title":"index__title__3Z_El","action":"index__action__2xqRb","content":"index__content__39lOC","extraContent":"index__extraContent__1F43F","main":"index__main__35cgx"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/index.less
// module id = 1101
// module chunks = 0